module.exports = __webpack_public_path__ + "img/QA.31372988.svg";